import {createContext} from 'react'

interface Alerts2ContextProps {
  searchTerm: string
  setSearchTerm: (term: string) => void
  setCurrentPage: (page: number) => void
  currentPage: number
}

const Alerts2Context = createContext<Alerts2ContextProps>({
  searchTerm: '',
  setSearchTerm: () => {},
  setCurrentPage: () => {},
  currentPage: 1,
})

export {Alerts2Context}
